module.exports = __webpack_public_path__ + "static/media/dep-lock.0335b5a2.svg";